import Vue from 'vue';
import Vuex from 'vuex';
import { firebaseAuth, firebaseDb, firebaseSt } from '@/database/firebase';
import { defaultsDeep } from 'lodash';

let messageRef;

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        app: {
            namespaced: true,
            state() {
                return {
                    token: null,
                    user: null,
                    messages: {},
                    codeList: [] as any,
                    menuList: null,
                    roleList: null,
                    treeMenuList: null,
                    showMenuPathName: null,
                    topMenuCode: null,
                    alert: {
                        value: false,
                        message: '',
                        callback() {},
                    },
                    confirm: {
                        value: false,
                        message: '',
                        oktext: '확인',
                        canceltext: '취소',
                        callback() {},
                    },
                    loading: {
                        zIndex: 9999,
                        overlay: false,
                    },
                };
            },
            getters: {
                GET_TOKEN: (state) => state.token,
                GET_USER: (state) => state.token,
                GET_CODE_LIST: (state) => state.codeList,
                GET_MENU_LIST: (state) => state.menuList,
                GET_TREE_MENU_LIST: (state) => state.treeMenuList,
                GET_ROLE_LIST: (state) => state.roleList,
                GET_ALERT: (state) => state.alert,
                GET_CONFIRM: (state) => state.confirm,
                GET_SHOW_MENU_PATH_NAME: (state) => state.showMenuPathName,
                GET_TOP_MENU_CODE: (state) => state.topMenuCode,
            },
            mutations: {
                SET_TOKEN(state, payload) {
                    state.token = payload;
                },
                SET_USER(state, payload) {
                    state.user = payload;
                },
                SET_CODE_LIST(state, payload) {
                    state.codeList = payload;
                },
                SET_MENU_LIST(state, payload) {
                    state.menuList = payload;
                },
                SET_TREE_MENU_LIST(state, payload) {
                    state.treeMenuList = payload;
                },
                SET_ROLE_LIST(state, payload) {
                    state.roleList = payload;
                },
                SET_ALERT(state, payload) {
                    state.alert = payload;
                },
                SET_SHOW_MENU_PATH_NAME(state, payload) {
                    state.showMenuPathName = payload;
                },
                SET_TOP_MENU_CODE(state, payload) {
                    state.topMenuCode = payload;
                },
                SET_CONFIRM(state, payload) {
                    state.confirm = payload;
                },
                SET_LOADING(state, payload) {
                    state.loading.overlay = payload;
                },
                setUserDetails(state, payload) {
                    state.userDetails = payload;
                },
                addMessage(state, payload) {
                    Vue.set(state.messages, payload.messageId, payload.messageDetails);
                },
                clearMessages(state) {
                    state.messages = {};
                },
            },
            actions: {
                firebaseGetMessages({ commit, state }, roomId) {
                    messageRef = firebaseDb.ref('chats/' + roomId);
                    messageRef.on('child_added', snapshot => {
                        let messageDetails = snapshot.val();
                        let messageId = snapshot.key;
                        let urlImg = messageDetails.name;
                        //     if (messageDetails.name !== undefined && messageDetails.name === urlImg) {
                        //              firebaseSt.ref('image/' + urlImg).getDownloadURL().then((url) => {
                        //             messageDetails.url = url;
                        //         });
                        //     }
                        // // firebaseDb.ref('chats/' + roomId + '/' + messageId).update(messageDetails);
                        commit('addMessage', {
                            messageId,
                            messageDetails,
                        });
                    });
                },
                firebaseStopGettingMessages({ commit }) {
                    if (messageRef) {
                        messageRef.off('child_added');
                        commit('clearMessages');
                    }
                },
                async firebaseSendMessage({}, payload) {
                    if(payload.message.name == null) {
                        firebaseDb.ref('chats/' + payload.roomId + '/').push(payload.message);
                    } else {
                        // let aaa = firebaseDb.ref('chats/' + payload.roomId + '/').push(payload.message).key;
                        let aaa = firebaseDb.ref('chats/' + payload.roomId + '/').push().key;
                        let bbb;
                        // firebaseDb.ref('chats/' + payload.roomId + '/').push(payload.message);
                        await firebaseSt.ref('image/' + payload.message.name).put(payload.file);
                        firebaseSt.ref('image/' + payload.message.name).getDownloadURL().then((url) => {
                            bbb = url;

                            let ccc: any = {};
                            ccc['chats/' + payload.roomId + '/' + aaa] = {
                                text: payload.message.text,
                                from: payload.message.from,
                                createDt: payload.message.createDt,
                                name: payload.message.name,
                                size: payload.message.size,
                                type: payload.message.type,
                                url: bbb,
                            };
                            // firebaseDb.ref('chats/' + payload.roomId + '/').push(payload.message);
                            firebaseDb.ref().update(ccc);
                        });
                    }
                },
            },
        },
    },

});
